import * as React from 'react';
import GoogleOptimize from './GoogleOptimize';
import MunchkinScript from './MunchkinScript';
import Mutiny from './Mutiny';
import OneTrust from './OneTrust';

if (typeof window !== 'undefined') (window as any).triggerMunchkinProductInterest = () => null;

const AllTheScripts = (): JSX.Element => (
  <>
    <GoogleOptimize />
    <OneTrust />
    <Mutiny />
    <MunchkinScript />
  </>
);

export default AllTheScripts;
